<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img"><img src="/assets/product/engine/4G15M/4G15M.jpg" alt=""></div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">4G15M 1.5T Port Fuel Injection Turbocharged Engine</div>
                <div class="detail-banner-desc">
                    The 4G15M is a 1.5T port fuel injection turbocharged engine delivering a maximum of 143 horsepower, featuring a wide stoichiometric air-fuel ratio operating range.
                </div>
            </div>
        </div>
    </div>

    <div class="detail-box">
        <div class="detail-title">Powerful Performance</div>
        <div class="detail-desc">Low initial speed for maximum torque with a broad effective range ensures smooth acceleration and ample power, enhancing driving refinement.</div>
        <div class="detail-utils">
            <div class="detail-utils-item">
                <div class="detail-utils-d">Maximum Power（5600-6000r/min）</div>
                <div class="detail-utils-u">105kW</div>
            </div>
            <div class="detail-utils-item">
                <div class="detail-utils-d">Maximum Torque（1800～4400r/min）</div>
                <div class="detail-utils-u">210N·m</div>
            </div>
            <div class="detail-utils-item">
                <div class="detail-utils-d">Low-Speed Torque</div>
                <div class="detail-utils-u">1000r/min 119N·m<br />1200r/min 131N·m</div>
            </div>
            <div class="detail-utils-item">
                <div class="detail-utils-d">Emission Standard</div>
                <div class="detail-utils-u">China 6b</div>
            </div>
        </div>

        <div class="detail-swiper-list detail-box">
            <div class="img-box detail-swiper-right ">
                <img src="/assets/product/engine/4G15M/4G15M-1.jpg" alt=""></img>
            </div>
            <div class="detail-swiper-left">
                <div>
                    <div class="detail-title">
                        Electronically Controlled Wastegate Turbocharger
                    </div>
                    <div class="detail-desc">
                        Reliable and high-performing.<br />
                        Provides responsive boost for improved driving comfort.
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="detail-box">
        <div class="detail-title">Low Fuel Consumption</div>
        <div class="detail-desc">Features a newly designed combustion system with high tumble-ratio ports, a higher compression ratio, multi-hole injectors, an integrated exhaust manifold in the cylinder head, CVVT, and a DOHC design for more efficient combustion and reduced fuel consumption.</div>
        <div class="detail-four-list">
            <div class="detail-four-item">
                <div class="img-box">
                    <img src="/assets/product/engine/4G15M/4G15M-2.jpg" alt=""></img>
                </div>
            </div>
            <div class="detail-four-item">
                <div class="detail-four-title">
                    Combustion System Optimization
                </div>
                <div class="detail-four-desc">
                    High tumble-ratio ports, higher compression ratio, and an integrated exhaust manifold improve in-cylinder turbulence and gas exchange efficiency. This enhances air-fuel mixing, combustion completeness, and thermal efficiency, reducing fuel consumption while meeting China 6 standards.
                </div>
            </div>
            <div class="detail-four-item">
                <div class="detail-four-title">
                    6bar Fuel Injection System + 8 holes Injector
                </div>
                <div class="detail-four-desc">
                    Improves fuel atomization and combustion efficiency for lower fuel consumption.
                </div>

            </div>
            <div class="detail-four-item">
                <div class="img-box">
                    <img src="/assets/product/engine/4G15M/4G15M-3.jpg" alt=""></img>
                </div>
            </div>
        </div>
    </div>


    <div class="detail-box">
        <div class="detail-title">NVH</div>
        <div class="detail-desc">Acoustic refinement has been enhanced through quiet-optimized components for a more pleasant engine sound.</div>
        <div class="detail-four-list">
            <div class="detail-four-item">
                <div class="img-box">
                    <img src="/assets/product/engine/4G15M/4G15M-4.jpg" alt=""></img>
                </div>
            </div>
            <div class="detail-four-item">
                <div class="detail-four-title">
                    Silent Toothed Chain
                </div>
                <div class="detail-four-desc">
                    Utilizes a silent toothed chain structure for the timing system, reducing meshing excitation noise of timing chain. Order noise is reduced by up to 8 dB(A), improving overall NVH.
                </div>

            </div>
            <div class="detail-four-item">
                <div class="detail-four-title">
                    Plastic Intake Manifold
                </div>
                <div class="detail-four-desc">
                    The intake manifold is made of plastic material to reduce engine noise and improve NVH.
                </div>

            </div>
            <div class="detail-four-item">
                <div class="img-box">
                    <img src="/assets/product/engine/4G15M/4G15M-5.jpg" alt=""></img>
                </div>
            </div>
        </div>
    </div>


    <div class="detail-swiper-list detail-box">
        <div class="img-box detail-swiper-right ">
            <img src="/assets/product/engine/4G15M/4G15M-6.jpg" alt=""></img>
        </div>
        <div class="detail-swiper-left">
            <div>
                <div class="detail-title">
                    Camshaft Profile Optimization
                </div>
                <div class="detail-desc">
                    Optimized the camshaft profile to lower valvetrain noise for improved acoustic performance.
                </div>
            </div>
        </div>
    </div>


    <Footer></Footer>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const swiperInstances = ref({});

onMounted(() => {
    nextTick(() => {
        const swiperContainers = document.querySelectorAll('.swiper-container');

        swiperContainers.forEach((container, index) => {
            const containerKey = `swiper_${index}`;
            container.dataset.swiperKey = containerKey;
            const swiperInstance = new Swiper(container, {
                loop: false,
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 300,
                preventClicks: true,
                effect: 'fade',
            });
            swiperInstances.value[containerKey] = swiperInstance;
        });

        bindTabClickEvent();
    });
});
function bindTabClickEvent() {
    const allSwiperLists = document.querySelectorAll('.detail-swiper-list');

    allSwiperLists.forEach((swiperList) => {
        const tabItems = swiperList.querySelectorAll('.detail-tab-item');
        const targetSwiperContainer = swiperList.querySelector('.swiper-container');

        if (!tabItems.length || !targetSwiperContainer) return;

        const containerKey = targetSwiperContainer.dataset.swiperKey;
        const targetSwiper = swiperInstances.value[containerKey];
        if (!targetSwiper) return;

        const handleTabAction = (tabItem, localTabIndex) => {
            tabItems.forEach(item => item.classList.remove('active'));
            tabItem.classList.add('active');
            targetSwiper.slideTo(localTabIndex, 300, true);
        };
        tabItems.forEach((tabItem, localTabIndex) => {
            const handleTabClickWrapper = () => {
                handleTabAction(tabItem, localTabIndex);
            };
            tabItem.removeEventListener('click', handleTabClickWrapper);
            tabItem.removeEventListener('mouseenter', handleTabClickWrapper);
            tabItem.addEventListener('click', handleTabClickWrapper);
            tabItem.addEventListener('mouseenter', handleTabClickWrapper);
        });
    });
}

</script>

<script>
export const pageConfig = {
  title: '4G15M 1.5T Port Fuel Injection Turbocharged Engine - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/engine/4G15M.html'

};

import { createApp } from 'vue';
import App from './4G15M.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import "@/assets/styles/product-details.scss"

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./4G15M.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>